module.exports = __webpack_public_path__ + "img/logo_portrait.f56b7092.png";